import { Color } from "@repo/app-types/constants/colors";
import {
  outcomeGreenRedYellowResultCategoryColor,
  type OutcomeGreenRedYellowResultCategory,
} from "@repo/app-types/entities/outcome";
import { getPillColor, type PillColor } from "@repo/ui/Pills/pill";

/**
 * Map an outcome result category (green / red / yellow / gray) to the Pill
 * color used to render it across the outcome editor. Falls back to gray.
 */
export function getOutcomeCategoryPillColor(
  category: OutcomeGreenRedYellowResultCategory,
): PillColor {
  const color = outcomeGreenRedYellowResultCategoryColor[category];
  return getPillColor(color) ?? Color.Gray;
}
